/* istanbul ignore file */
import { deletedProjectAction, deleteProjectsTabAction, restoreProjectAction, resource, savedProjectsTabAction, purshasedProjectsTabAction, currentTabNameAction, projectsCountState, ProjectsCountStateTypes, makeProjectsActionType, ProjectsCountAction } from "../action";
import ActionTypes from "../../constants";

// @ts-ignore
const logger = photoOrg.clientLogger;
// @ts-ignore
const enablePermanentDelete = photoOrg.config.enablePermanentDelete;

export const savedProjects = (prevState:resource[] =null,action: savedProjectsTabAction | deletedProjectAction): resource[] => {
    try{
        if(action.type === ActionTypes.SAVED){
            if(!prevState){
                return action.payload.resources;
            }
            return [ ...prevState, ...action.payload.resources]
        }else if(action.type === ActionTypes.DEL_SAVED_PROJECT){
            return prevState.filter((project)=> project.resource.id !== action.payload.projectId);
        }
        
    } catch(error){
        logger.error({description: "NEW PROJECTS:Reducers:savedProjects:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }
    return prevState;
}

export const deletedProjects = (prevState:resource[]=null,action: deleteProjectsTabAction | restoreProjectAction):resource[] => {
    try{
        if(action.type===ActionTypes.DELETED){
            if(!prevState){
                return action.payload.resources;
            }
            return [ ...prevState, ...action.payload.resources]
        }else if(action.type === ActionTypes.RESTORE_DELETED_PROJECT){
            return prevState.filter((project)=> project.resource.id !== action.payload.projectId);
        }
    } catch(error){
        logger.error({description: "NEW PROJECTS:Reducers:deletedProjects:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }
    return prevState;
}

export const purchasedProjects = (prevState:resource[]=null,action: purshasedProjectsTabAction | deletedProjectAction):resource[] => {   
    try{
        if(action.type=== ActionTypes.PURCHASED){
            if(!prevState){
                return action.payload.resources;
            }
            return [ ...prevState, ...action.payload.resources]
        }else if(action.type === ActionTypes.DEL_PURCHASED_PROJECT){
            return prevState.filter((project)=> project.resource.id !== action.payload.projectId);
        }
    } catch(error){
        logger.error({description: "NEW PROJECTS:Reducers:purchasedProjects:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }
    return prevState;
}

const convertCountStateStringToNumber = (state:projectsCountState, action: ProjectsCountAction) => {
    if(action.payload && action.payload.tabName === ActionTypes.SAVED){
        state.saved = parseInt(action.payload.data.count);
        state.savedSubCounts = action.payload.data.subCounts;
    }else if(action.payload && action.payload.tabName ===ActionTypes.PURCHASED){
        state.purchased = parseInt(action.payload.data.count);
    }else if(action.payload && action.payload.tabName === ActionTypes.SOFT_DELETED){
        state.deleted = parseInt(action.payload.data.count);
    }
    return state;
}

const doCalculationOnCountState = (state:projectsCountState, action: restoreProjectAction | deletedProjectAction) => {
    switch(action.type){
        case ActionTypes.RESTORE_DELETED_PROJECT:
            if(action.payload.projectState === ActionTypes.DELETED_ARCHIVED){
                state.purchased += 1;
            }else{
                state.saved += 1;
            }            
            state.deleted -= 1;
            break;
        case ActionTypes.DEL_SAVED_PROJECT:
            state.saved -= 1;
            if(!enablePermanentDelete){
                state.deleted += 1;
            }
            break;
        case ActionTypes.DEL_PURCHASED_PROJECT:
            state.purchased -= 1;
            state.deleted += 1;
    }
}

export const projectsCount = (
    state:projectsCountState = {saved:0,purchased:0,deleted:0, savedSubCounts: {}},
    action) => {
    try{
        convertCountStateStringToNumber(state,action);
        doCalculationOnCountState(state,action);
        return state;
    } catch(error){
        logger.error({description: "LIBRARY:Reducers:projectsCount:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }

    return state;
}

export const saveTabName = (state:ActionTypes.SAVED = ActionTypes.SAVED,action: currentTabNameAction) => {
    try{
        if(action.type === ActionTypes.CURRENT_TAB_NAME){
            return action.payload 
        }
    } catch(error){
        logger.error({description: "LIBRARY:Reducers:saveTabName:Exception", errorCode: "LIBRARY:MYPROJECTS", err_desc: error.message, err_stack: error.stack});
    }
    return state;
}

export function lastAction(state = null, action) {
    return action;
}

